<div class="c-collection-box">
	{{#with collection}}
		<div class="collection-header">
			<span class="header-text">Selected files</span>
			{{#if collection}}
				<span class="remove-text" on-click="@this.set('collection', [])">Remove all</span>
			{{/if}}
		</div>

		<div class="collection-list">
			{{#each this}}
				<div as-sortable class="collection-item">
					<span><a href="/package/{{type}}/{{name}}">{{name}}</a>{{file}}</span>
					<img width="20"
						height="20"
						src="{{@shared.assetsHost}}/img/icons/remove-icon.svg"
						loading="lazy"
						on-click="@this.splice('collection', @index, 1)"
						as-tooltip="'Remove this file'">
				</div>
			{{else}}
				<div class="box-message">
					No files selected. Select the files you want to use using the switches on the left.
				</div>
			{{/each}}
		</div>

		{{#if this}}
			<a on-click="slide-next" class="config-btn">
				Show &amp; Configure all links
			</a>
		{{/if}}
	{{/with}}
</div>

<script>
	const tooltip = require('../../assets/js/decorators/tooltip');

	component.exports = {
		decorators: {
			tooltip,
		},
	};
</script>
